import React, { FunctionComponent } from 'react';
import Checkbox from '../Checkbox';
import { IBindingCallback1 } from '../../common/models/callback';
import styles from './styles.module.scss';
import { DashboardColor } from '../../common/enums/DashboardColor';
import CheckboxFilterItem from '../CheckboxFilterItem';

interface IRadioFilterItemProps {
  id: string;
  name: string;
  count: number;
  color: DashboardColor;
  onSelect: IBindingCallback1<string>;
  isSelected: boolean;
  intlId?: string;
  defaultText?: string;
}

const RadioFilterItem: FunctionComponent<IRadioFilterItemProps> = ({
  id,
  onSelect,
  isSelected,
  ...rest
}) => (
  <div
    className={`d-flex flex-row align-items-center ${styles.item}`}
    role="presentation"
    onClick={() => onSelect(id)}
  >
    <div className={styles.checkboxWrapper}>
      <Checkbox checked={isSelected} radio onChange={() => onSelect(id)} />
    </div>
    <div className={styles.sidebarItemWrapper}>
      <CheckboxFilterItem id={id} {...rest} />
    </div>
  </div>
);

export default RadioFilterItem;
